import api from '@/apis/sa/sASaleInvoiceAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('sASaleInvoice', api);

const state = {
  ...crud.state,
  _config: {
    table: 'sa_sale_invoice',
    field: {
      key: 'ref_id',
      transaction: 'transaction_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Update lại trường hạch toán màn hình danh sách
   * @param {*} context
   * @param {*} res
   * NNLINH 10.10.2022
   */
  updatedPosted(context, res) {
    context.commit('updatedPosted', res);
  },

  /**
   * Update lại trạng thái phát hành màn hình danh sách
   * @param {*} context
   * @param {*} res
   * tvhien 11.10.2022
   */
  updatedPublishStatus(context, res) {
    context.commit('updatedPublishStatus', res);
  },

  /**
   * Update lại trạng thái gửi hóa đơn
   * @param {*} context
   * @param {*} res
   * NNLINH 12.10.2022
   */
  updatedSendEmailStatus(context, res) {
    context.commit('updatedSendEmailStatus', res);
  },

  /**
   * Update lại trạng thái hóa đơn hủy
   * @param {*} context
   * @param {*} res
   * TTLONG 12.10.2022
   */
  updateInvoiceStatusCancelled(context, res) {
    context.commit('updateInvoiceStatusCancelled', res);
  },
};
const mutations = {
  ...crud.mutations,

  /**
   * Update lại trường hạch toán ngoài màn hình danh sách
   * @param {*} state
   * @param {*} ids
   * NNLINH 10.10.2022
   */
  updatedPosted(state, ids) {
    let keyField = state._config.field.key;
    if (ids.length) {
      ids.forEach(id => {
        for (let i = 0; i < state.items.length; i++) {
          let item = state.items[i];

          if (item[keyField] === id) {
            let itemNew = { ...item };
            itemNew.is_posted = true;
            //Check xem nếu có thay đổi ở cấu trúc tree thì thì assign lại data để thực hiện build lại cấu trúc
            Object.assign(item, itemNew);
            break;
          }
        }
      });
    }
  },

  /**
   * Update lại trạng thái phát hành màn hình danh sách
   * @param {*} context
   * @param {*} res
   * tvhien 11.10.2022
   */
  updatedPublishStatus(state, res) {
    let keyField = state._config.field.key;
    EventBusGlobal.$emit('SASaleInvoice/refresh');
  },

  /**
   * Update lại trạng thái gửi hóa đơn màn hình danh sách
   * @param {*} context
   * @param {*} res
   * NNLINH 12.10.2022
   */
  updatedSendEmailStatus(state, transactionIds) {
    let transactionField = state._config.field.transaction;
    if (transactionIds.length) {
      transactionIds.forEach(transactionId => {
        for (let i = 0; i < state.items.length; i++) {
          let item = state.items[i];

          if (item[transactionField] === transactionId) {
            let itemNew = { ...item };
            itemNew.send_email_status = 1;
            //Check xem nếu có thay đổi ở cấu trúc tree thì thì assign lại data để thực hiện build lại cấu trúc
            Object.assign(item, itemNew);
            break;
          }
        }
      });
    }
  },
  /**
   * Update lại trạng thái hóa đơn hủy
   * TTLONG 12.10.2022
   */
  updateInvoiceStatusCancelled(state, refId) {
    if (refId) {
      for (let i = 0; i < state.items.length; i++) {
        let item = state.items[i];
        if (item.ref_id === refId) {
          let itemNew = { ...item };
          itemNew.invoice_status = 2;
          //Check xem nếu có thay đổi ở cấu trúc tree thì thì assign lại data để thực hiện build lại cấu trúc
          Object.assign(item, itemNew);
          break;
        }
      }
    }
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
